import { render, staticRenderFns } from "./CalificacionesIndex.vue?vue&type=template&id=2890d34a"
import script from "./CalificacionesIndex.vue?vue&type=script&lang=js"
export * from "./CalificacionesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports